"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.year = exports.month = exports.day = exports.dateConfig = exports.DateDefinition = void 0;

var _config = require("../config");

var _types = require("../../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var day = {
  key: 'day',
  placeholder: 'DD',
  maxLength: 2,
  type: 'number',
  ui: {
    classes: 'col span_2_of_12'
  },
  validation: []
};
exports.day = day;
var month = {
  key: 'month',
  placeholder: 'MM',
  maxLength: 2,
  type: 'number',
  ui: {
    classes: 'col span_2_of_12'
  },
  validation: []
};
exports.month = month;
var year = {
  key: 'year',
  placeholder: 'YYYY',
  maxLength: 4,
  type: 'number',
  ui: {
    classes: 'col span_2_of_12'
  },
  validation: []
};
exports.year = year;
var dateConfig = {
  type: 'date',
  validation: [{
    date: true
  }]
};
exports.dateConfig = dateConfig;

var DateDefinition = _flowRuntime["default"].type("DateDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(FieldElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("date")), _flowRuntime["default"].property("value", _flowRuntime["default"].string(), true))));

exports.DateDefinition = DateDefinition;